// SPDX-FileCopyrightText: 2017-2022 City of Espoo
//
// SPDX-License-Identifier: LGPL-2.1-or-later

import React from 'react'

import {
  daycareAssistanceLevels,
  preschoolAssistanceLevels
} from 'lib-common/generated/api-types/assistance'
import type { EmployeeCustomizations } from 'lib-customizations/types'

import { employeeConfig } from './appConfigs'
import MunicipalityLogo from './assets/municipality-logo-primary.svg'
import featureFlags from './featureFlags'

const customizations: EmployeeCustomizations = {
  appConfig: employeeConfig,
  translations: {
    fi: {
      common: {
        retroactiveConfirmation: {
          checkboxLabel:
            'Ymmärrän, olen asiasta yhteydessä Lumijoen laskutukseen *'
        }
      },
      footer: {
        cityLabel: 'Lumijoki kunta',
        linkLabel: 'Lumijoen varhaiskasvatus',
        linkHref: 'https://www.lumijoki.fi/varhaiskasvatus-ja-perusopetus/'
      },
      unitEditor: {
        placeholder: {
          email: 'etunimi.sukunimi@Lumijoki.fi',
          url: 'esim. https://www.Lumijoki.fi/fi/toimipisteet/15585',
        }
      },
      welcomePage: {
        text: 'Olet kirjautunut sisään Lumijoen kunnan eVaka-palveluun. Käyttäjätunnuksellesi ei ole vielä annettu oikeuksia, jotka mahdollistavat palvelun käytön. Tarvittavat käyttöoikeudet saat omalta esimieheltäsi.'
      },
      preferredFirstName: {
        description:
      'Voit määritellä eVakassa käytössä olevan kutsumanimesi. Kutsumanimen tulee olla jokin etunimistäsi. Jos nimesi on vaihtunut ja sinulla on tarve päivittää eVakaan uusi nimesi, ole yhteydessä Lumijoen pääkäyttäjiin.',
      },
      login: {
        loginAD: 'Lumijoen AD',
      },
      incomeStatement: {
        noIncomeTitle:
        'Ei mitään tuloja tai tukia, tiedot saa tarkastaa tulorekisteristä.',
        incomesRegister:
          'Hyväksyn, että tuloihini liittyviä tietoja tarkastellaan tulorekisteristä.',
        checkupConsent:
        'Hyväksyn, että tuloihini liittyviä tietoja tarkastellaan tarvittaessa tulorekisteristä.',
        limitedCompanyIncomesRegister:
        'Tuloni voi tarkastaa tarvittaessa tulorekisteristä.',
      },
    },
    sv: {},
  },

  cityLogo: <img src={MunicipalityLogo} alt="Lumijoki logo" data-qa="footer-city-logo" />,
  featureFlags,
  placementTypes: [
    'PRESCHOOL',
    'PRESCHOOL_DAYCARE',
    'DAYCARE',
    'DAYCARE_PART_TIME',
  ],
  absenceTypes: [
    'OTHER_ABSENCE',
    'SICKLEAVE',
    'UNKNOWN_ABSENCE',
    'PLANNED_ABSENCE',
    'PARENTLEAVE',
    'FORCE_MAJEURE',
  ],
  daycareAssistanceLevels: [...daycareAssistanceLevels],
  otherAssistanceMeasureTypes: [
    'TRANSPORT_BENEFIT',
    'ACCULTURATION_SUPPORT',
    'ANOMALOUS_EDUCATION_START',
  ],
  placementPlanRejectReasons: ['REASON_1', 'REASON_2', 'OTHER'],
  preschoolAssistanceLevels: [...preschoolAssistanceLevels],
  unitProviderTypes: [
    'MUNICIPAL',
    'PURCHASED',
    'PRIVATE',
    'MUNICIPAL_SCHOOL',
    'PRIVATE_SERVICE_VOUCHER',
    'EXTERNAL_PURCHASED',
  ],
  voucherValueDecisionTypes: [
    'NORMAL',
    'RELIEF_ACCEPTED',
    'RELIEF_PARTLY_ACCEPTED',
    'RELIEF_REJECTED',
  ],
  additionalStaffAttendanceTypes: [
    'OTHER_WORK',
    'TRAINING',
    'JUSTIFIED_CHANGE',
    'SICKNESS',
    'CHILD_SICKNESS',
  ],

}

export default customizations
